import type { FeedItem } from '@/types/api';

export interface SummaryPoint {
  text: string;
  items: FeedItem[];
}

export interface CategoryData {
  points: SummaryPoint[];
  otherItems: FeedItem[];
}

export interface CategorizedNews {
  safety: CategoryData;
  urgent: CategoryData;
  important: CategoryData;
  informational: CategoryData;
  events?: SortedEventsResponse;  // Optional sorted events
}

export interface SortedEvent {
  item: FeedItem;
  relevanceScore: number;
  reason: string;
}

export interface SortedEventsResponse {
  events: SortedEvent[];
  holidayContext: string | null;
}

export async function categorizeNews(
  _zipcode: string,
  cityName: string,
  items: FeedItem[],
  safetyItems: FeedItem[] = []
): Promise<CategorizedNews> {
  console.log(`[GPT] Calling backend to categorize ${items.length} items, ${safetyItems.length} safety items`);

  const response = await fetch('/api/gpt/categorize', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      cityName,
      items,
      safetyItems,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error(`[GPT] Error response: ${errorText}`);
    throw new Error(`GPT API error: ${response.status}`);
  }

  const result = (await response.json()) as CategorizedNews;
  console.log('[GPT] Categorization complete');
  return result;
}

export async function sortLocalEvents(
  cityName: string,
  items: FeedItem[],
  currentDate?: string
): Promise<SortedEventsResponse> {
  console.log(`[GPT] Sorting ${items.length} local events for ${cityName}`);

  const response = await fetch('/api/gpt/sort-events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      cityName,
      items,
      currentDate: currentDate || new Date().toISOString(),
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    console.error(`[GPT] Error response: ${errorText}`);
    throw new Error(`GPT API error: ${response.status}`);
  }

  const result = (await response.json()) as SortedEventsResponse;
  console.log(`[GPT] Sorted ${result.events.length} events, context: ${result.holidayContext}`);
  return result;
}
